<template>
  <div style="padding-left: 5px">
    <div :class="['word-list', { 'word-list-alone': !needNotice }]">
      <div
        class="word-list-con"
        :style="{ transform: 'translateX(-' + donghua + 'px)' }"
      >
        <transition name="fade" mode="out-in">
          <div class="word-list-con">
            <div
              :class="{
                'is-active': indexWord == index % size,
                'is-right': indexWord < index % size,
                'is-active-wrong': indexWord == index % size && isWrong,
              }"
              v-for="(word, indexWord) in currentStr()"
              :key="'word' + indexWord"
              class="letter"
            >
              {{ word }}
            </div>
          </div>
        </transition>
      </div>
    </div>
    <div class="board_notice" v-if="needNotice">
      <div
        :class="{
          'is-notice-active': indexWord == index,
          'is-notice-right': indexWord < index,
          'is-space': word === ' ',
        }"
        v-for="(word, indexWord) in inputStr"
        :key="'word' + indexWord"
        class="notice_letter"
      >
        {{ word }}
      </div>
    </div>
    <successDialog
      v-if="showDialog"
      @clickConfirm="clickConfirm"
      @clickClose="clickClose"
      :is-confirm-dialog="true"
      :dialog-title="'Congratulations'"
      :dialog-img="dialogImg"
    >
    </successDialog>
  </div>
</template>

<script>
import dialog from "../views/mixins/dialog";
export default {
  props: {
    inputStr: {
      // 输入参数
      // inputStr: "ahjsajhsahSKJhakjshakjSHKJhsakjhAS", // 输入字符串
      type: String,
    },
    needNotice: {
      type: Boolean,
      default: false,
    },
    dialogImg: {
      type: String,
      default: "",
    },
  },
  mixins: [dialog],
  data() {
    return {
      showDialog: false,
      size: 8, // 分组大小
      index: 0, // 当前索引
      isWrong: false, // 当前是否错误
      // 初始化字母 和 状态 对应  第一个状态是is-active 其他事未点击状态
      timer: null,
      donghua: 0,
    };
  },
  watch: {
    $route() {
      this.isWrong = false; // 当前是否错误
      this.index = 0;
      this.timer = null;
    },
  },
  mounted() {},
  methods: {
    clickClose() {
      console.log("关闭暂缓");
      this.showDialog = false;
    },
    clickConfirm() {
      this.showDialog = false;
    },
    currentStr() {
      return this.inputStr.substring(
        parseInt(this.index / this.size) * this.size,
        Math.min(
          parseInt(this.index / this.size) * this.size + this.size,
          this.inputStr.length
        )
      );
    },
    removeKey(key) {
      if (this.inputStr[this.index] === key) {
        clearTimeout(this.timer);
        this.isWrong = false;
        this.index++;
        if (this.inputStr.length <= this.index) {
          // alert("恭喜完成任务");
          this.showDialog = true;
        }
      } else {
        this.isWrong = true;
        this.timer = setTimeout(() => {
          this.isWrong = false;
        }, 700);
      }
    },
    nextWord() {
      return this.inputStr[this.index];
    },
    nextKey() {
      let nextKeyVal = "";
      if (this.index === 0) {
        nextKeyVal = this.inputStr[this.index];
        // this.index<=1?this.inputStr[this.index]:this.inputStr[this.index+1]
      } else {
        nextKeyVal = this.inputStr[this.index + 1];
      }
      return nextKeyVal;
    },
  },
};
</script>

<style scoped lang="less">
.dialogDetail {
  box-sizing: border-box;
  padding: 0 8px;
  p {
    text-align: center;
    font-size: 24px;
  }
}
.word-list {
  padding: 10px 0;
  margin: 0 auto;
  width: 800px;
  height: 82px;
  display: flex;
  overflow: hidden;
}
.word-list-alone {
  margin: 100px auto;
}
.word-list-con {
  display: flex;
  min-width: 100%;
}
.letter {
  background: #fff;
  border: 1px solid #d5d5d5;
  color: #4a4a4a;
  display: inline-block;
  -ms-flex: 1;
  flex: 1;
  line-height: 80px;
  height: 80px;
  margin-right: 5px;
  width: 12%;
  border-radius: 5px;
  text-align: center;
  font-size: 40px;
}
.letter:last-child {
  margin-right: 0;
}
.is-right {
  background: #edf7e7;
  color: #95c590;
  transition: color 0.12s ease-in-out;
}
.is-active {
  background-color: #3295db;
  color: #fff;
}
.is-active-wrong {
  background-color: #d55b60;
  border-color: #ffdcd9;
  border-radius: 5px;
  color: #fff;
  animation-name: shock;
  animation-duration: 0.7s;
}

.board_notice {
  width: 800px;
  display: flex;
  flex-wrap: wrap;
  margin: 0 auto;
  font-size: 32px;
  .is-space {
    width: 0.5em;
  }
  .is-notice-active {
    animation-name: breathe;
    animation-duration: 1700ms;
    animation-iteration-count: infinite;
  }
  @-webkit-keyframes breathe {
    0% {
      color: #95c590;
    }
    50% {
      color: #4a4a4a;
      opacity: 0.5;
    }
    100% {
      color: #95c590;
    }
  }
  .is-notice-right {
    color: #95c590;
  }
}
@keyframes shock {
  0%,
  100% {
    transform: translateX(0);
  }
  10%,
  30%,
  50%,
  70%,
  90% {
    transform: translateX(-5px);
  }
  20%,
  40%,
  60%,
  80% {
    transform: translateX(5px);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
